// Frontend-only event registry for the certificate minting platform.
// Add a new object here to support a new event — no backend/admin panel needed.
// `eventId` is used on-chain (duplicate-mint protection key) so it must never change
// once an event has gone live with real mints.
//
// `templateImageSrc` is optional. Point it at a static image under `public/`
// (e.g. "/certificate-templates/blocktalk-2026.jpeg") to use a designed
// background for that event's certificate instead of the generated gradient.
// Templated certificates are rendered at the source image's native
// resolution (see utils/renderCertificate.js) and are assumed to already
// contain the title, organizer branding, and event/college name printed in
// — only the participant's name, a verification QR, and compact footer text
// are drawn on top. If the field is omitted, or the image fails to load, the
// themed gradient background with the full generated text layout is used
// instead.
const MST_ORGANIZER = "Masterstroke Technosoft Pvt. Ltd.";
const MST_THEME = {
  primary: "#ee0000",
  secondary: "#730000",
  background: "#0c0c0c",
  accent: "#ffffff"
};

export const events = [
  {
    eventId: "campusverse-jaywant-2026",
    name: "CampusVerse Workshop — Jaywant College of Engineering and Polytechnic",
    date: "2026-08-31",
    dateLabel: "31 August 2026",
    venue: "Jaywant College of Engineering and Polytechnic, Pune, Maharashtra",
    organizer: MST_ORGANIZER,
    certificateType: "Participation Certificate",
    status: "active",
    templateImageSrc: "/certificate-templates/jaywant.jpeg",
    theme: MST_THEME
  },
  {
    eventId: "blocktalk-2026",
    name: "BLOCKTALK by MST Blockchain",
    date: "2026-08-03",
    dateLabel: "03 August 2026",
    venue: "C. Kesavan Memorial Town Hall, Kollam, Kerala",
    organizer: MST_ORGANIZER,
    certificateType: "Participation Certificate",
    status: "active",
    templateImageSrc: "/certificate-templates/blocktalk-2026(2).jpeg",
    theme: MST_THEME
  },
  {
    eventId: "campusverse-tkm-2026",
    name: "CampusVerse Workshop — TKM College of Engineering",
    date: "2026-08-04",
    dateLabel: "04 August 2026",
    venue: "TKM College of Engineering, Kollam, Kerala",
    organizer: MST_ORGANIZER,
    certificateType: "Participation Certificate",
    status: "active",
    templateImageSrc: "/certificate-templates/tkm-college-of-engineering.jpeg",
    theme: MST_THEME
  },
  {
    eventId: "campusverse-amaljyothi-2026",
    name: "CampusVerse Workshop — Amal Jyothi College of Engineering",
    date: "2026-08-03",
    dateLabel: "03 August 2026",
    venue: "Amal Jyothi College of Engineering, Kanjirappally, Kottayam, Kerala",
    organizer: MST_ORGANIZER,
    certificateType: "Participation Certificate",
    status: "active",
    templateImageSrc: "/certificate-templates/amal-jyothi-college-of-engineering.jpeg",
    theme: MST_THEME
  },
  {
    eventId: "campusverse-stjosephs-2026",
    name: "CampusVerse Workshop — St Joseph's College Of Engineering",
    date: "2026-08-03",
    dateLabel: "03 August 2026",
    venue: "St Joseph's College Of Engineering, Chennai, Tamil Nadu",
    organizer: MST_ORGANIZER,
    certificateType: "Participation Certificate",
    status: "active",
    templateImageSrc: "/certificate-templates/st-josephs-college-of-engineering.jpeg",
    theme: MST_THEME
  },
  {
    eventId: "campusverse-cek-2026",
    name: "CampusVerse Workshop — College of Engineering Karunagappally",
    date: "2026-08-04",
    dateLabel: "04 August 2026",
    venue: "College of Engineering Karunagappally, Kollam, Kerala",
    organizer: MST_ORGANIZER,
    certificateType: "Participation Certificate",
    status: "active",
    templateImageSrc: "/certificate-templates/college-of-engineering-karunagappally.jpeg",
    theme: MST_THEME
  },
  {
    eventId: "campusverse-viswajyothi-2026",
    name: "CampusVerse Workshop — Viswajyothi College of Engineering and Technology",
    date: "2026-08-03",
    dateLabel: "03 August 2026",
    venue: "Viswajyothi College of Engineering and Technology, Vazhakulam, Kerala",
    organizer: MST_ORGANIZER,
    certificateType: "Participation Certificate",
    status: "active",
    templateImageSrc: "/certificate-templates/viswajyothi-college-of-engineering-and-technology.jpeg",
    theme: MST_THEME
  },
  {
    eventId: "campusverse-rit-2026",
    name: "CampusVerse Workshop — Rajarambapu Institute of Technology",
    date: "2026-08-31",
    dateLabel: "31 August 2026",
    venue: "Rajarambapu Institute of Technology, Rajaramnagar, Sangli, Maharashtra",
    organizer: MST_ORGANIZER,
    certificateType: "Participation Certificate",
    status: "active",
    templateImageSrc: "/certificate-templates/rit.jpeg",
    theme: MST_THEME
  }
];

export const getActiveEvents = () => events.filter((e) => e.status === "active");

export const getEventById = (eventId) => events.find((e) => e.eventId === eventId);
